import clock from './asda-clock.svg'
import facebook from './asda-facebook.svg'
import help from './asda-help.svg'
import info from './asda-info.svg'
import offer from './asda-offer.svg'
import price from './asda-price.svg'
import twitter from './asda-twitter.svg'
import unavailable from './asda-unavailable.svg'
import ingredient from './asda-ingredient.svg'

import circleMinus from './asda-circle-minus.svg'
import circlePlus from './asda-circle-plus.svg'
import circlePound from './asda-pound.svg'

export default {
  clock,
  facebook,
  help,
  info,
  offer,
  price,
  twitter,
  unavailable,
  ingredient,
  'circle-minus': circleMinus,
  'circle-plus': circlePlus,
  circlePound,
}



// WEBPACK FOOTER //
// ./common/components/icon/circular/index.js